function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg057Venezuela(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    y: 144.685,
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 222.62
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "422.957,300.778 410.908,310.192 416.137,324.558 403.459,316.01 391.411,325.423    395.625,310.725 382.949,302.173 398.229,301.641 402.445,286.944 407.676,301.312  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "392.103,247.341 384.002,260.309 393.83,272.019 378.994,268.324 370.891,281.288    369.822,266.036 354.986,262.335 369.165,256.608 368.1,241.353 377.928,253.068  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "344.834,207.677 341.656,222.633 354.897,230.279 339.691,231.881 336.512,246.834    330.292,232.868 315.086,234.464 326.449,224.231 320.23,210.265 333.472,217.909  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "286.851,186.574 288.981,201.716 304.038,204.37 290.295,211.075 292.423,226.217    281.803,215.217 268.058,221.92 275.238,208.419 264.615,197.422 279.674,200.075  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "225.148,186.574 232.328,200.075 247.383,197.418 236.763,208.421 243.94,221.922    230.199,215.217 219.576,226.214 221.706,211.075 207.962,204.374 223.021,201.716  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "167.165,207.677 178.53,217.909 191.768,210.265 185.552,224.236 196.913,234.466    181.708,232.868 175.486,246.834 172.311,231.878 157.104,230.282 170.346,222.635  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "119.896,247.341 134.076,253.068 143.901,241.357 142.838,256.612 157.013,262.34    142.177,266.039 141.109,281.288 133.009,268.324 118.172,272.022 128.001,260.309  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "89.043,300.778 104.328,301.312 109.555,286.945 113.774,301.644 129.053,302.179    116.376,310.728 120.59,325.426 108.543,316.012 95.866,324.561 101.096,310.192  "
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFDA44"
    },
    width: 512,
    height: 144.685
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg057Venezuela);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };